interface OfferListExtraHeading {
  id: string
  heading: string
  position: number
}

/**
 * Remaps absolute streamed offer-list separator positions onto a client-paginated
 * page slice. Separators at the page end boundary belong to the next page.
 */
function getPageRelativeOfferListExtras<T extends OfferListExtraHeading>(
  extras: Array<T>,
  page: number,
  pageSize: number,
): Array<T> {
  if (pageSize <= 0) return []

  const pageStart = page * pageSize

  return extras
    .map((extra) => ({
      ...extra,
      position: extra.position - pageStart,
    }))
    .filter((extra) => extra.position >= 0 && extra.position < pageSize)
}

export default getPageRelativeOfferListExtras
